import React from 'react'
import { Box } from 'rebass'
import { Text } from 'rebass'
import { observer } from 'mobx-react'

// stores
import GameStore from 'App/stores/GameStore'

import TableNames from 'App/components/table/TableNames'
import TablePlayerHands from 'App/components/table/TablePlayerHands'

@observer
class TableHands extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (
      <Box
        sx={{
          width: [240, 340],
          height: [240, 340],
          borderWidth: 2,
          borderColor: 'red',
          // borderStyle: 'solid',
          position: 'absolute',
          left: '50%',
          ml: [-120, -170],
          top: '50%',
          mt: [-120, -170]
        }}
      >
        <TableNames />
        <TablePlayerHands currentPlayer={this.props.currentPlayer} handData={this.props.handData} cardClicked={this.props.cardClicked} clickCloseMarker={this.props.clickCloseMarker} />
      </Box>
    )
  }
}
export default TableHands
